// extracted by mini-css-extract-plugin
module.exports = {"ContactForm":"ContactPage_ContactForm__1Ywhz","SuccessMessage":"ContactPage_SuccessMessage__120ax","FailMessage":"ContactPage_FailMessage__2EDM9"};